const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/_root/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AppListFilterParamSchema } from '@apps/main/features/user/pages/app/list-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/_root/list')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: AppListFilterParamSchema
});